import React, { useState, useEffect } from 'react';
import { useFirestore } from '../hooks/useFirestore';
import ProjectCard from '../components/ProjectCard';

const ProjectManagementPage = () => {
  const [projects, setProjects] = useState([]);
  const { getProjects, addProject } = useFirestore();
  const [newProject, setNewProject] = useState({ title: '', description: '', budget: '', timeline: '' });

  useEffect(() => {
    const fetchProjects = async () => {
      const fetchedProjects = await getProjects();
      setProjects(fetchedProjects);
    };
    fetchProjects();
  }, [getProjects]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProject(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addProject(newProject);
    setNewProject({ title: '', description: '', budget: '', timeline: '' });
    const updatedProjects = await getProjects();
    setProjects(updatedProjects);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Gestión de Proyectos</h1>

      <form onSubmit={handleSubmit} className="mb-8 p-4 bg-gray-100 rounded-lg">
        <h2 className="text-xl font-semibold mb-4">Nuevo Proyecto</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input
            type="text"
            name="title"
            value={newProject.title}
            onChange={handleInputChange}
            placeholder="Título del proyecto"
            className="w-full p-2 border rounded"
            required
          />
          <input
            type="number"
            name="budget"
            value={newProject.budget}
            onChange={handleInputChange}
            placeholder="Presupuesto"
            className="w-full p-2 border rounded"
            required
          />
          <input
            type="text"
            name="timeline"
            value={newProject.timeline}
            onChange={handleInputChange}
            placeholder="Plazo (ej: 3 meses)"
            className="w-full p-2 border rounded"
            required
          />
          <textarea
            name="description"
            value={newProject.description}
            onChange={handleInputChange}
            placeholder="Descripción del proyecto"
            className="w-full p-2 border rounded"
            required
          ></textarea>
        </div>
        <button type="submit" className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
          Agregar Proyecto
        </button>
      </form>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects.map(project => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default ProjectManagementPage;